import SchemaForm from 'app/schema-form/components/schema-form';
import { LoaderButton } from '../../../../common/daisy/loader-button.tsx';
import type { ToolEditorProps } from './tool-editor-hook.js';

export function ToolEditor(props: ToolEditorProps) {
  const { initialData, form, formValidator, formWidgets, handleSubmit, hasPendingChanges, hasErrors } = props;

  return form ? (
    <>
      <div className="flex items-center justify-between mb-3 sticky top-0 bg-base-100 z-10">
        <h4 className="font-semibold text-md">Edit Tool</h4>
        <LoaderButton loading={hasPendingChanges} className="btn" onClick={handleSubmit} disabled={hasErrors}>
          {hasPendingChanges ? 'Saving' : 'Save'}
        </LoaderButton>
      </div>
      <SchemaForm widgets={formWidgets} initialData={initialData} validator={formValidator} {...form} />
    </>
  ) : null;
}
